import { Component, Inject } from '@angular/core';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { JobCustomItem } from '../../shared/models/job.custom.item.interface';
import { JobService } from '../services/job.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Focus } from 'ngx-quill';
import {  NgForm } from '@angular/forms';

@Component({
  selector: 'app-job-custom-work-area-dialog',
  templateUrl: './job-custom-work-area-dialog.html',
  styleUrl: './job-custom-work-area-dialog.scss'
})
export class JobCustomWorkAreaDialog extends AbstractBiditComponent {
  customItem: JobCustomItem = {} as JobCustomItem;
  customItemId!: number;
  hasWorkOrders: boolean = true;

  constructor(
    private jobService: JobService,
    deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<JobCustomWorkAreaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(deviceDetectorService);

    this.customItem.quote_ID = data.quote_ID;
    this.customItemId = data.customItem_ID;
    if (this.customItemId !== null) {
      this.ngOninit();
    }
  }

  ngOninit() {
    if (this.customItemId !== null) {

      this.isRequesting = true;
      this.jobService.getCustomItem(this.data.quote_ID, this.customItemId)
        .subscribe({
          next: (x) => {
            this.customItem = x;
            this.hasWorkOrders = x.workOrders.length > 0;
            this.isRequesting = false;
          },
          error: (error: string) => this.onError(error)
        });
    }
  }

  saveCustomAreaItem(form: NgForm) {
    this.isRequesting = true;
    if (form.invalid) return;

    this.jobService.saveCustomItem(this.customItem.quote_ID, this.customItem)
      .subscribe({
        next: (x) => {
          this.isRequesting = false;         
          this.dialogRef.close();
        },
        error: (error: string) => this.onError(error)
      });
  }

  deleteCustomAreaItem(custumItemId: number) {
    this.isRequesting = true;
    this.jobService.removeCustomItem(custumItemId)
      .subscribe({
        next: (x) => {
          this.isRequesting = false;
          window.alert($localize`delete complete`);
          this.dialogRef.close();
        },
        error: (error: string) => this.onError(error)
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
